import React, { useState } from 'react'
import { IoMdLock } from "react-icons/io";
import { HiMiniEye, HiMiniEyeSlash } from "react-icons/hi2";


const PasswordField = ({ password, setPassword }) => {
    const [showPass, setShowPass] = useState(false);
    const [passFieldType, setPassFieldType] = useState('password');

    const togglePass = () => {
        setShowPass(!showPass);
        setPassFieldType(passFieldType === 'password' ? 'text' : 'password')
    }

    return (
        <div className="relative">
            <label htmlFor="password" className="block mb-2 text-sm font-semibold text-gray-900">Password<span className='text-orange'>*</span></label>
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 mt-[27px]">
                <IoMdLock size={20} className="text-gray-500" />
            </div>
            <input
                type={passFieldType}
                autocomplete="off"
                name="password"
                id="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Enter password"
                className="bg-gray-50 pr-8 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5"
                
            />
            <div className="absolute inset-y-0 right-0 flex items-center mr-2 mt-[27px] cursor-pointer">
                {!showPass ? <HiMiniEye onClick={togglePass} size={20} className="text-gray-500" />
                    : <HiMiniEyeSlash onClick={togglePass} size={20} className="text-gray-500" />
                }
            </div>
        </div>
    )
}

export default PasswordField